import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PrincipalComponent } from './principal.component';
import { PrincipalRoutingModule } from './principal.routing';
import { HeaderModule } from './components/header/header.module';
import { MainModule } from './pages/main.module';
import { FooterModule } from './components/footer/footer.module';

@NgModule({
  declarations: [
    PrincipalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,

    HeaderModule,
    MainModule,
    FooterModule,

    PrincipalRoutingModule
  ],
  exports: [
    PrincipalComponent
  ]
})

export class PrincipalModule { }
